import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AddFriend } from './add-friend';

@Injectable()
export class AddFriendService {

    private requirePopupSource = new Subject<AddFriend>();
    private acceptPopupSource = new Subject<AddFriend>();
    private deletePopupSource = new Subject<AddFriend>();
    private updatePopupSource = new Subject<AddFriend>();
    // Observable string sources
    private tasks = new Subject<any>();
    // Observable string streams
    tasksConfirmed$ = this.tasks.asObservable();

    requirePopup$ = this.requirePopupSource.asObservable();
    accept = this.acceptPopupSource.asObservable();
    delete = this.deletePopupSource.asObservable();
    update = this.updatePopupSource.asObservable();

    confirm(popup: AddFriend) {
        this.requirePopupSource.next(popup);
        return this;
    }

    onAccept() {
        this.acceptPopupSource.next();
    }

    onDelete() {
        this.deletePopupSource.next();
    }

    onUpdate() {
        this.updatePopupSource.next();
    }

    postTask(task: any) {
        this.tasks.next(task);
    }

}
